import { Modal } from 'app-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import AccordionPanel from '../../../components/common/app-components/AccordionPanel';
import { IAlertData } from './CapAlertContainer';

interface CapAlertModalProps {
    onClose: () => void;
    alertData: IAlertData;
    handelRedirection: (data: any) => void;
}

const CapAlertModal: React.FC<CapAlertModalProps> = ({ onClose, alertData, handelRedirection }) => {
    const { hhFirstName, hhLastName, needAttention, statues, specialMessage } = alertData;

    return (
        <Modal id="cap-actions-modal">
            <Modal.Header
                id="cap-actions-modal-header"
                titleId={`${hhFirstName} ${hhLastName}`}
                onHide={onClose}
            ></Modal.Header>
            <Modal.Body>
                <AccordionPanel
                    id={'special-message'}
                    ariaControlsId="additionnalInfoPanel"
                    header={<FormattedMessage id="cap.alerts.specialMessage" />}
                    isHeaderClickable={true}
                    isInitialExpanded={true}
                >
                    {specialMessage ? specialMessage : <FormattedMessage id="common.none" />}
                </AccordionPanel>

                <div className="scrollable-content">
                    <div className="attention-list">
                        <div className="header-text">
                            <FormattedMessage id="cap.alerts.needAttention" />
                        </div>
                        <ul>
                            {needAttention.map(data => (
                                <li
                                    key={data.id}
                                    className={data.color.toLocaleLowerCase()}
                                    onClick={() => handelRedirection(data)}
                                >
                                    {data.buttonText}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="status-list">
                        <div className="header-text">
                            <FormattedMessage id="cap.alerts.statuses" />
                        </div>
                        <ul>
                            {statues.map(data => (
                                <li key={data.id} className={data.color.toLocaleLowerCase()}>
                                    {data.buttonText}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CapAlertModal;
